import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import GenericListPage from '../GenericListPage';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AdminSubscriptionTransactions = () => {
  const query = useQuery();
  const subscriptionId = query.get('subscriptionId') || '';

  const columns = useMemo(() => [
    {
      header: 'Date',
      key: 'date',
      render: (item) =>
        item.createdAt
          ? new Date(item.createdAt).toLocaleString()
          : '-',
    },
    {
      header: 'Customer Id',
      key: 'customer_id',
    },
    {
      header: 'Payment Id',
      key: 'paymentId',
    },
    {
      header: 'Subscription Id',
      key: 'subscriptionId',
    },
    {
      header: 'Plan',
      key: 'planName',
      render: (item) => item.subscriptionOrder?.subscription_plan || 'N/A',
    },
    {
      header: 'Payment Method',
      key: 'method',
    },
    {
      header: 'Amount',
      key: 'amount',
      render: (item) => `${item.amount} ${item.currency || 'USD'}`,
    },
    {
      header: 'Status',
      key: 'status',
      render: (item) => (
        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
          item.status === 'success'
            ? 'bg-green-100 text-green-800'
            : item.status === 'pending'
            ? 'bg-yellow-100 text-yellow-800'
            : 'bg-red-100 text-red-800'
        }`}>
          {item.status?.charAt(0).toUpperCase() + item.status?.slice(1)}
        </span>
      ),
    },
    {
      header: 'Transaction ID',
      key: '_id',
    },
  ], []);

  const filterConfig = useMemo(() => [
    {
      label: 'Status',
      name: 'status',
      type: 'select',
      options: [
        { label: 'Success', value: 'success' },
        { label: 'Captured', value: 'captured' },
        { label: 'Authorized', value: 'authorized' },
        { label: 'Failed', value: 'failed' },
        { label: 'Pending', value: 'pending' },
        { label: 'Paid', value: 'paid' },
        { label: 'Refunded', value: 'refunded' },
        { label: 'Voided', value: 'voided' },
      ],
    },
    {
      label: 'Plan',
      name: 'planName',
      type: 'text',
      placeholder: 'Plan Name',
    },
    {
      label: 'From Date',
      name: 'fromDate',
      type: 'date',
    },
    {
      label: 'To Date',
      name: 'toDate',
      type: 'date',
    },
    {
      label: 'Subscription Id',
      name: 'subscriptionId',
      type: 'text',
      placeholder: 'Subscription Id',
    },
  ], []);

  // Set defaultFilters so the filter is pre-filled and applied
  const defaultFilters = useMemo(() => ({
    subscriptionId,
  }), [subscriptionId]);

  return (
    <GenericListPage
      title="Subscription Transactions"
      entityEndpoint="subscription-transactions"
      columns={columns}
      filterConfig={filterConfig}
      permission="view_subscription_transactions"
      hideActions={true}
      defaultFilters={defaultFilters}
    />
  );
};

export default AdminSubscriptionTransactions;